import { isEqual, uniqWith } from "lodash";
import { gatewayInstance } from "../server/gateway";
import ImService from "@/server/ImService";
import { convertUIDToString } from "@jd/focus-desktop-comps/lib/es/utils";
import { convertEmployeeToString } from "@/utils/chat/message";
import { Employee } from "@/types/chat";
import { unzipData } from "@/utils";

export interface EGroupGroupsRes {
  labelId: string;
  groups: {
    gid: string;
  }[];
}

export interface GroupCleanMsgPageReq {
  pageNo: number;
  pageSize: number;
  groupId: string;
}

export interface GroupCleanMsgPageResp {
  pageCount: number;
  pageNo: number;
  pageSize: number;
  total: number;
  list: Record<string, any>[];
}

/**
 *
 * 根据分组 id 获取用户群组 gid
 * @param {Schedule} schedule
 * @param {*} opts labelId写死为1 ,ebookType：1：我创建的；2：我加入的
 * @returns
 */
export async function getGroupsByLabel({
  labelId,
  ebookType
}: {
  labelId: string;
  ebookType?: string;
}): Promise<EGroupGroupsRes> {
  return gatewayInstance.request({
    api: "egroup.getGroupsByLabel",
    method: "POST",
    body: {
      labelId,
      ebookType
    }
  });
}

export interface EGroupGroupInfo {
  name: string;
  avatar: string;
  rosterSize: number;
  gid: string;
  kind: number;
  subKind: number;
  business: string;
  businessId: string;
  ext: any;
  flag?: number;
  status?: number;
  max?: number;
}

export interface EGroupGroupInfoRes {
  type: number;
  groups: EGroupGroupInfo[];
}

export interface EGroupCommonLimitRule {
  allowMuteGroup: boolean;
}

// 根据群组 id 批量获取群组信息
export async function getGroupInfo({
  groupIds
}: {
  groupIds: string[] | { groupId: any }[];
}): Promise<EGroupGroupInfoRes> {
  return await gatewayInstance.request({
    api: "egroup.groupGetInfo",
    method: "POST",
    body: { type: 5, groupIds }
  });
}

// 获取当前用户建群限制规则
export async function getGroupSizeLimitRule(user: any): Promise<EGroupGroupInfoRes> {
  const { app, teamId, pin } = user;
  return await gatewayInstance.request({
    api: "egroup.GroupSizeLimitRule",
    method: "POST",
    body: { app, teamId, pin }
  });
}

// 获取当前用户群管控规则统用接口（首期纸返回禁言管控配置）
export async function getCommonLimitRule(user: any): Promise<EGroupCommonLimitRule> {
  const { app, teamId, pin } = user;
  return await gatewayInstance.request({
    api: "egroup.CommonLimitRule",
    method: "POST",
    body: { app, teamId, pin }
  });
}

/**
 * 获取组擦除记录
 * @param options
 * @returns
 */
export async function getGroupCleanRecord(
  options: GroupCleanMsgPageReq
): Promise<GroupCleanMsgPageResp> {
  const res: GroupCleanMsgPageResp = await gatewayInstance.request({
    api: "egroup.getGroupCleanMsgRecord",
    method: "POST",
    body: options
  });
  if (res?.list?.length) {
    const users = uniqWith(res?.list, (a: any, b: any) => {
      const uid1 = convertUIDToString({
        app: a.app,
        pin: a.pin,
        teamId: a.teamId
      });
      const uid2 = convertUIDToString({
        app: b.app,
        pin: b.pin,
        teamId: b.teamId
      });
      return uid1 === uid2;
    }).map((i) => {
      return {
        userId: i.pin,
        teamId: i.teamId,
        appId: i.app
      };
    });
    const userDetails = await ImService.getInstance().getChangeUserDetailList(users);
    res.list = res.list.map((i) => {
      const uid = {
        app: i.app,
        pin: i.pin,
        teamId: i.teamId
      };
      const u = userDetails.find(
        (user) => convertEmployeeToString(user as Employee) === convertUIDToString(uid)
      );
      return {
        ...i,
        avatar: u?.avatar || "",
        unitName: u?.unitName || "",
        name: u?.name || "",
        labelInfoList: u?.labelInfoList || []
      };
    });
  }
  return res;
}

export interface BotListItem {
  botId: string;
  teamId: string;
  app: string;
}

// 群聊添加机器人
export async function groupBotAdd({
  groupId,
  nickName,
  botList
}: {
  groupId: string;
  nickName: string;
  botList: Array<BotListItem>;
}) {
  return await gatewayInstance.request({
    api: "egroup.groupBotAdd",
    method: "POST",
    body: { groupId, nickName, origin: 0, botList }
  });
}

// 群聊删除机器人
export async function groupBotDelete({
  groupId,
  nickName,
  botList
}: {
  groupId: string;
  nickName: string;
  botList: Array<BotListItem>;
}) {
  return await gatewayInstance.request({
    api: "egroup.groupBotDelete",
    method: "POST",
    body: { groupId, nickName, origin: 0, botList }
  });
}

// 获取当前群机器人列表
export async function groupGetBotList({ groupId }: { groupId: string }) {
  return await gatewayInstance.request({
    api: "egroup.groupGetBotList",
    method: "POST",
    body: { groupId }
  });
}

// 查询机器人详情
export async function getRobotChangeUserDetailList(robots: any[]) {
  const res: any = await gatewayInstance.request({
    api: "ebook.gov.getChangeUserDetailList",
    method: "POST",
    body: { ebookVersionReqs: [...robots] }
  });
  console.log("ressssssss~~~:", res);
  try {
    const uData: string = await unzipData(res);
    const result = JSON.parse(uData);
    // 测试环境接口返回alias，不用重新map遍历获取
    // const newList = list.map((item: any) => {
    //   const alias = getUserAlias(item.info, selectedSession);
    //   return { ...item, alias };
    // });
    console.log("unziped list Data:", result);
    return result;
  } catch (e) {
    console.log("getUserGroupDetailList--unzipData error", e);
    return [];
  }
}
